import { fetchComponent, checkStatus, fetchPaths, } from './fetchComponent';
import { traverse, sortObject, } from './traverse';
import { requireAuth, isLoggedIn, getMFAPath, getMFASetupPath, } from './routing';
import { getParameterized, parameterize, setParameters, findMatchingRoute, } from './parameterize';
import { fetchErrorContent, fetchSuccessContent, fetchDynamicContent, fetchAction, _handleDynamicParams, getDynamicFunctionName, confirmModalPopUp, } from './dynamics';
import { setCacheConfiguration, getCacheConfiguration, flushCacheConfiguration, loadCacheConfigurations, } from './cache_configuration';
import { get404Error, } from './errors';

export default {
  fetchComponent,
  checkStatus,
  fetchPaths,
  traverse,
  requireAuth,
  isLoggedIn,
  getParameterized,
  parameterize,
  setParameters,
  findMatchingRoute,
  fetchAction,
  fetchErrorContent,
  fetchSuccessContent,
  fetchDynamicContent,
  setCacheConfiguration,
  getCacheConfiguration,
  flushCacheConfiguration,
  loadCacheConfigurations,
  get404Error,
  _handleDynamicParams,
  sortObject,
  getMFAPath,
  getMFASetupPath,
  getDynamicFunctionName,
  confirmModalPopUp,
};
